import OnboardingLoader from "./OnboardingLoader";
export default OnboardingLoader;
